import { ladderAccess, levelSomewhere, servicesHome } from '@church/data'
import { atLeast } from '@church/permissions'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { SermonSearchPage } from '../components/services/Sermons.tsx'
import { useBreadcrumbs } from '../lib/breadcrumbs.ts'

/**
 * Sermons: "What have we preached on…?" — the church's sermons by words,
 * theme or book (docs/15, "Sermon writing"). Editor on a service type.
 */
export const Route = createFileRoute('/_authed/_shell/services/_sections/sermons/')({
  beforeLoad: ({ context }) => {
    const held = ladderAccess(context.me)
    if (!atLeast(levelSomewhere(held, 'planning'), 'editor'))
      throw redirect({ to: servicesHome(held), replace: true })
  },
  component: SermonsScreen,
})

function SermonsScreen() {
  useBreadcrumbs([{ label: 'Sermons' }])
  return <SermonSearchPage />
}
